import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui/IconButton';
import { cn } from '@/lib/utils';

import type { DelegatedView } from '../use-delegated-view';

export const DelegatedToggle = observer(({ view }: { view: DelegatedView }) => {
  if (!view.available) return null;
  return (
    <IconButton
      id="feed-delegated-toggle"
      icon={Icons.attendees}
      size="default"
      scale={0.7}
      aria-label="Delegated"
      aria-pressed={view.open}
      aria-controls="feed-tab-content"
      tooltip={view.open ? 'Back to feed' : 'Delegated'}
      className={cn('shrink-0', view.open && 'bg-secondary hover:bg-secondary')}
      onClick={view.toggle}
    />
  );
});
